import React from 'react';
import classNames from 'classnames';

export type DialogActionsProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * Footer action-row for a `Dialog`, replacing `ModalActionButtonContainer`.
 * Lays out its children (typically `Button`s) in a wrapping row with consistent spacing.
 *
 * Renders a plain `div` on purpose: `Dialog.Block` triggers `.ds-dialog:has(> .ds-dialog__block)`,
 * which removes the dialog's own padding and expects every child to be a block.
 */
const DialogActions: React.FC<DialogActionsProps> = ({ className, children, ...rest }) => {
  return (
    <div
      className={classNames('flex', 'flex-wrap--wrap', 'align-items--center', 'gap--2', className)}
      {...rest}
    >
      {children}
    </div>
  );
};

export default DialogActions;
